import styled from 'styled-components'

import rightBranch from 'assets/images/brench-right-grey-icon.svg'

import { Color } from 'root-constants'

export const StyledTrustPilotBannerVariant2 = {
  Container: styled.div`
    width: 90%;
    display: flex;
    align-items: center;
    gap: 12px;

    border-radius: 8px;
    background-color: ${Color.SKY_LIGHTER};

    padding: 8px;
    margin-bottom: 16px;
  `,
  Text: styled.p`
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    color: ${Color.INK_LIGHT};
  `,
  BoldText: styled.p`
    font-size: 18px;
    font-weight: 700;
    line-height: 20px;
    text-align: center;
    color: ${Color.INK_DARKER};
  `,
  Content: styled.div`
    width: 40%;

    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    &::after,
    &::before {
      content: '';
      position: absolute;
      width: 25%;
      top: 55%;
      aspect-ratio: 110 / 140;
      background: url(${rightBranch}) no-repeat center/contain;
      transform: translateY(-50%);
      pointer-events: none;
    }

    &::after {
      right: -3px;
    }

    &::before {
      left: -3px;
      transform: translateY(-50%) scaleX(-1);
    }
  `,
}
